module.exports = __webpack_public_path__ + "static/DIHK2-ac073d73a1f592eaa4edea1dddc5be5d.png";